import { StateStore } from "../../app/state/StateStore";
import { ScreenMapper } from "./ScreenMapper";
import type { NoticeScreen } from "../../app/api/ApiClient";

export class NoticeScreenMapper
    implements ScreenMapper<NoticeScreen> {

    readonly type = "notice" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    apply(screen: NoticeScreen): void {

        const state = this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "notice",

                noticeType:
                    screen.noticeType === "next"
                        ? "next_available"
                        : screen.noticeType,

                nextKrokId:
                    screen.nextKrokId ?? null,

                notice:
                    screen.data ?? [],

                continueProducts:
                    screen.continueProducts ?? []

            },

            isLoading: false

        });

    }

}